/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class PropertyDiligenceCasesAPI extends ApiClient {
  constructor() {
    super('property_diligence_cases', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  create(payload) {
    return axios.post(this.url, payload, requestConfig());
  }

  operationalStatus(params = {}) {
    return axios.get(
      withQuery(resourcePath(this.url, 'operational_status'), params),
      requestConfig()
    );
  }

  promotionGate(params = {}) {
    return axios.get(
      withQuery(resourcePath(this.url, 'promotion_gate'), params),
      requestConfig()
    );
  }

  addEvidence(id, payload) {
    return axios.post(
      resourcePath(this.url, id, 'add_evidence'),
      payload,
      requestConfig()
    );
  }

  collectRegistryIdentity(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'collect_registry_identity'),
      payload,
      requestConfig()
    );
  }

  recordSourceAttempt(id, payload) {
    return axios.post(
      resourcePath(this.url, id, 'record_source_attempt'),
      payload,
      requestConfig()
    );
  }

  reviewItem(id, payload) {
    return axios.post(
      resourcePath(this.url, id, 'review_item'),
      payload,
      requestConfig()
    );
  }

  refreshStatus(id) {
    return axios.post(
      resourcePath(this.url, id, 'refresh_status'),
      {},
      requestConfig()
    );
  }
}

export default new PropertyDiligenceCasesAPI();
